export default {
    VILLAGER : 'VILLAGER',
    WEREWOLF : 'WEREWOLF',
    OTHER : 'OTHER'
}